// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

import { TARGET_FIELD_MODE } from "./constants";

export const TargetFieldModePropType = PropTypes.oneOf(
  Object.values(TARGET_FIELD_MODE)
);
